'use client'

import BigText from './BigText'
import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'

export default function CTASection() {
  const pathname = usePathname()

  // Check if we're in the academy section
  const isInAcademy = pathname.startsWith('/academy')

  // Dynamic button content based on current route
  const buttonText = isInAcademy ? 'ZU DEN CAMPS' : 'ZUR ACADEMY'
  const buttonHref = isInAcademy ? '/saac-camps' : '/academy'

  return (
    <section className="relative z-40 bg-white pt-32 text-center">
      <div className="absolute bottom-[-50px] left-0 right-0 top-0 bg-cover bg-center md:bottom-[-150px] 2xl:bottom-[-350px]">
        <Image
          src="/footer-bg.svg"
          alt="Footer Berg"
          className="h-full w-full object-contain object-bottom"
          width={1000}
          height={1000}
        />
      </div>

      <div className="relative z-10 mt-8 text-center">
        <p className="mb-4 text-xl">Bereit für deine Abenteuer im alpinen Gelände?</p>
        <div className="mb-8 px-4">
          <BigText text="Schütze dich & die Umwelt" light={true} absolute={false} wrap={true} />
        </div>

        <Link
          href={buttonHref}
          className="inline-block border border-black bg-accent px-6 py-3 text-button transition-colors hover:bg-accent/80"
        >
          {buttonText}
        </Link>
      </div>
    </section>
  )
}
